import { BaseApi, ResponseEntity } from "@/utils/request";

export class CommonApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * getTopContent
   */
  public getTopContent(ContentType: number): Promise<ResponseEntity> {
    return this.get("/Contents/GetBasicContentByType", {
      ContentType,
      start: 1,
      limit: 10,
      page: 1,
      orderColunm: "ID",
      orderDir: "ASC",
    });
  }

  /**
   * getBanner
   */
  public getAdInfo(adType: number): Promise<ResponseEntity> {
    return this.get("/Contents/GetAdInfo", {
      adType,
    });
  }

  /**
   * getBanner
   */
  public getHistoryList(): Promise<ResponseEntity> {
    return this.get("/Customer/GetHistoryList");
  }

  /**
   * 登录并返回用户信息
   */
  public login(code: string) {
    return this.post("/Customer/Login", { code });
  }
}
